export const areBannerDatesValid = (
    startDate: string,
    expireDate: string,
): boolean => {
    const now = Date.now()
    const start = new Date(startDate ?? '').getTime()
    const expire = new Date(expireDate ?? '').getTime()
    return (
        Number.isFinite(start) &&
        Number.isFinite(expire) &&
        start <= now &&
        now <= expire
    )
}

export const isBannerForCurrentPage = (
    bannerPageUrl: string,
    currentPageUrl: string,
): boolean => {
    if (bannerPageUrl === '') return true

    const target = bannerPageUrl.replace(/\/+$/, '') ?? '/'
    const current = currentPageUrl.replace(/\/+$/, '') ?? '/'

    return current === target || current.startsWith(`${target}/`)
}
